<router-outlet></router-outlet>

<feedbackdialog
  #fdComponent
  [configuration]="feedbackDialogConfiguration"
  [reverseProxyType]="reverseProxyType"
  [authenticationType]="authenticationType"
></feedbackdialog>
